import Vue from 'vue'
import Generator from '@/libs/generator'
import data_config from '@/data/config.json'
import data_biomes from '@/data/cards/biome.json'

const get_default_state = function() {
	return {
		current: {
			status: 'not-started',
			location: 'main',
			biome: {},
			level: 1,
			main: { position: 1, row: 0, board: [] },
			chest: { position: 1, row: 0, board: [], card: false },
			golden_chest: { position: 1, row: 0, board: [], card: false },
		},
		stats: {
			cards: {
				monster: 0,
				heal: 0,
				shield: 0,
				gold: 0,
				drop: 0,
				item: 0,
				place: 0,
				biome: 0
			}
		},
		player: {
			hero: {}
		},
		biomes: {
			all: data_biomes,
			done: []
		},
		hover_card: false,
		config: data_config
	}
}

const game = {

	state: get_default_state(),

	getters: {
		game: function(state) { return state },
		current: function(state) {
			var temp = {
				status: state.current.status,
				level: state.current.level,
				location: state.current.location,
				biome: state.current.biome
			}
			temp.row = state.current[state.current.location].row
			temp.board = state.current[state.current.location].board
			temp.position = state.current[state.current.location].position
			return temp
		},
		shield_card_modifier: function(state) {
			var modifier = 0
			for (var i in state.player.hero.bag) {
				var card = state.player.hero.bag[i]
				if (card.slug == 'shiny-shield') modifier += 1
				if (card.slug == 'rusty-shield') modifier -= 1
			}
			return modifier
		},
		heal_card_modifier: function(state) {
			var modifier = 0
			for (var i in state.player.hero.bag) {
				var card = state.player.hero.bag[i]
				if (card.slug == 'raw-meat') modifier += 1
				if (card.slug == 'rotten-meat') modifier -= 1
			}
			return modifier
		},
		monster_card_modifier: function(state) {
			var modifier = 0
			for (var i in state.player.hero.bag) {
				var card = state.player.hero.bag[i]
				if (card.slug == 'monster-skull') modifier += 1
			}
			return modifier
		},
		gold_card_multiplier: function(state) {
			var multiplier = 0
			for (var i in state.player.hero.bag) {
				var card = state.player.hero.bag[i]
				if (card.slug == 'amethyst') multiplier += 1
			}
			return multiplier
		},
		hero_life_max_modifier: function(state) {
			var modifier = 0
			if (_.findIndex(state.player.hero.bag, { slug: 'ring-of-vitality' }) > -1) modifier += 5
			for (var i in state.player.hero.bag) {
				var card = state.player.hero.bag[i]
				if (card.slug == 'omelette') modifier += 3
			}
			if (_.findIndex(state.player.hero.bag, { slug: 'cursed-shield' }) > -1) {
				modifier = -(state.player.hero.life_max - 1)
			}
			return modifier
		},
		types_rates: function(state) {
			var rates = []
			if (state.current.status != 'not-started') {
				rates = _.cloneDeep(state.config[state.current.location].levels[state.current.level].rates.types)
				for (var i in state.player.hero.bag) {
					var card = state.player.hero.bag[i]
					if (card.slug == 'rusty-shield') {
						if (!rates.shield) rates.shield = 0
						rates.shield += 20
					}
					if (card.slug == 'shiny-shield') {
						if (!rates.shield) rates.shield = 0
						rates.shield -= 20
					}
				}
			}
			return rates
		},
		monster_values: function(state) {
			var rates = []
			if (state.current.status != 'not-started') {
				rates = _.cloneDeep(state.config[state.current.location].levels[state.current.level].rates.monster_values)
			}
			return rates
		},
		loot_rates: function(state) {
			if (state.current.status != 'not-started') {
				var rates = _.cloneDeep(state.config['main'].levels[state.current.level].rates.loot_types)
				for (var i in state.player.hero.bag) {
					var card = state.player.hero.bag[i]
					if (card.slug == 'horn') {
						if (!rates.heal) rates.heal = 0
						rates.heal += 20
					}
					if (card.slug == 'scales') {
						if (!rates.shield) rates.shield = 0
						rates.shield += 20
					}
					if (card.slug == 'fossil') {
						if (!rates.monster) rates.monster = 0
						rates.monster += 10
					}
				}
			}
			return rates
		},
		nb_rows_hidden: function(state) {
			var n = 0
			for (var i in state.player.hero.bag) {
				var card = state.player.hero.bag[i]
				if (card.slug == 'monster-eye') n++
			}
			if (n > 2) n = 2
			return n
		},
	},



	actions: {

		clean_game: function({ commit }) {
			commit('RESET_GAME_STATE')
		},

		init_game: function({ commit, dispatch, state, getters }, data) {
			commit('RESET_GAME_STATE')
			// commit('SET_GAME_STATE', { config: data_config, player: { hero: _.cloneDeep(data.hero) } })
			commit('SET_GAME_STATE', { player: { hero: _.cloneDeep(data.hero) } })

			dispatch('init_board')
			setTimeout(function() {
				dispatch('init_draw')
			}, 1000)

			var biome = _.sample(_.filter(state.biomes.all, { level: 1 }))
			commit('ADD_IN_BIOMES_DONE', { biome: biome })
			commit('EDIT_CURRENT', { biome: biome, status: 'not-ready' })

			commit('EDIT_PLAYER_HERO', { life: state.player.hero.life_max + getters.hero_life_max_modifier, shield: state.player.hero.shield, gold: state.player.hero.gold })
		},

		init_level: function({ commit, dispatch }) {
			dispatch('init_board')
			Vue.nextTick(function() {
				dispatch('init_draw')
			})
		},

		init_board: function({ commit, state }) {
			var board = []

			var nb_rows = state.config[state.current.location].levels[state.current.level].rows
			for (var i = 0; i < nb_rows; i++) {
				var row = { id: i, slots: [] }
				for (var j = 0; j < 3; j++) {
					row.slots.push({ id: _.uniqueId(), row: i, position: j, card: false })
				}
				board.push(row)
			}

			commit('EDIT_CURRENT', { board: board, row: 0 })
		},

		init_draw: function({ commit, state, getters }) {
			var board = _.clone(state.current[state.current.location].board)
			var config = state.config[state.current.location].levels[state.current.level]
			var nb_rows = board.length
			var nb_deal = 0

			// Place
			if (config.nb_places) {
				for (var i = 0; i < config.nb_places; i++) {
					var r = _.random(0, nb_rows - 3)
					var s = _.random(0, 2)
					var slug = Generator.get_random_number_by_rates(config.rates.places)
					board[r].slots[s].card = Generator.get_random_card({ type: 'place', slug: slug })
					if (r < 3) nb_deal++
				}
			}

			// Items
			if (config.nb_items) {
				for (var i = 0; i < config.nb_items; i++) {
					var r = _.random(0, nb_rows - 3)
					var s = _.random(0, 2)
					board[r].slots[s].card = Generator.get_random_card({ type: 'item' })
					if (r < 3) nb_deal++
				}
			}

			// Complete board
			for (var i in board) {
				var row = board[i]

				// NEXT BIOMES
				if (state.current.location == 'main' && i == nb_rows - 1) {

					if (state.current.level == 6) {
						var card = {
							type: 'end', slug: 'end',
							en: { name: "", description: "" },
							fr: { name: "", description: "" }
						}
						commit('SET_CARD_ON_SLOT', { slot: row.slots[1], card: card })
					}

					else {
						var remaining_biomes = _.filter(state.biomes.all, function(biome) {
							return _.findIndex(state.biomes.done, biome) == -1
						})

						for (var j = 1; j <= 3; j++) {
							var biomes = _.shuffle(_.filter(remaining_biomes, { level: j }))
							if (biomes.length > 0) {
								if (biomes.length == 1) {
									var card = Generator.get_random_card({ type: 'biome', slug: biomes[0].slug })
									commit('SET_CARD_ON_SLOT', { slot: row.slots[1], card: card })

								}
								else if (biomes.length == 2) {
									var card = Generator.get_random_card({ type: 'biome', slug: biomes[0].slug })
									commit('SET_CARD_ON_SLOT', { slot: row.slots[0], card: card })

									var card = Generator.get_random_card({ type: 'biome', slug: biomes[1].slug })
									commit('SET_CARD_ON_SLOT', { slot: row.slots[2], card: card })
								}
								else if (biomes.length == 3) {
									for (var k in biomes) {
										var card = Generator.get_random_card({ type: 'biome', slug: biomes[k].slug })
										commit('SET_CARD_ON_SLOT', { slot: row.slots[k], card: card })
									}
								}
								break
							}
						}
					}
				}
				
				// BOSS
				else if (state.current.location == 'main' && i == nb_rows - 2) {
					var card = Generator.get_random_card({ type: 'monster', biome: state.current.biome.slug, boss: true })
					card.boss = true
					row.slots[1].card = card
					commit('SET_CARD_ON_SLOT', { slot: row.slots[1], card: card })
					if (i < 3) nb_deal++
				}
				
				// FIRST LINE
				else if (state.current.location == 'main' && i == 0) {
					for (var j in row.slots) {
						if (!row.slots[j].card) {
							var type = Generator.get_random_number_by_rates(_.pickBy(getters.types_rates, function(rate, i) { return i != 'monster' }))
							var card = Generator.get_random_card({ type: type })
							commit('SET_CARD_ON_SLOT', { slot: row.slots[j], card: card })
							nb_deal++
						}
					}
				}
				
				// PLACE GO BACK
				else if (state.current.location != 'main' && i == nb_rows - 1) {
					var card = Generator.get_random_card({ type: 'biome', slug: state.current.biome.slug })
					card['fr'].name = card['fr'].back_sentence
					card['en'].name = card['en'].back_sentence
					card.hide_illustration = true
					card.no_hover = true
					commit('SET_CARD_ON_SLOT', { slot: row.slots[1], card: card })
					if (i < 3) nb_deal++
				}

				else {
					var nb_cards = parseInt(Generator.get_random_number_by_rates(config.rates.nb_cards_by_row))
					if (nb_cards == 2)
						var side = _.sample([ [0, 1], [0, 2], [1, 2] ])

					for (var j in row.slots) {
						var slot = row.slots[j]
						if (!slot.card) {
							var card = false

							if (nb_cards == 1) {
								if (j == 1) {
									var params = { type: Generator.get_random_number_by_rates(getters.types_rates) }
									if (params.type == 'monster') {
										params.biome = state.current.biome.slug
										params.value = Generator.get_random_number_by_rates(getters.monster_values)
									}
									card = Generator.get_random_card(params)
								}
							}
							else if (nb_cards == 2) {
								if (j == side[0] || j == side[1]) {
									var params = { type: Generator.get_random_number_by_rates(getters.types_rates) }
									if (params.type == 'monster') {
										params.biome = state.current.biome.slug
										params.value = Generator.get_random_number_by_rates(getters.monster_values)
									}
									card = Generator.get_random_card(params)
								}
							}
							else if (nb_cards == 3) {
								var params = { type: Generator.get_random_number_by_rates(getters.types_rates) }
								if (params.type == 'monster') {
									params.biome = state.current.biome.slug
									params.value = Generator.get_random_number_by_rates(getters.monster_values)
								}
								card = Generator.get_random_card(params)
							}
							
							if (card) {
								commit('SET_CARD_ON_SLOT', { slot: slot, card: card })
								if (i < 3) nb_deal++
							}
						}
					}
				}
			}

			var delay = 0
			for (var i = 0; i < nb_deal; i++) {
				setTimeout(function() {
					Sounds.play('deal-card')
				}, delay)
				delay += 120
			}

			// commit('EDIT_CURRENT', { board: board, row: 0 })
			commit('EDIT_CURRENT', { status: 'ready' })
		},

		play_card: function({ commit, state, dispatch, getters }, data) {
			
			if (data.card) {
				var temp_hero = {}

				dispatch('add_stat', { card: data.card })

				// CREATURE
				if (data.card.type == 'monster') {
					var value = (data.card.value + getters.monster_card_modifier)
					if (state.player.hero.shield > 0) {
						var shield = state.player.hero.shield - value
						if (shield < 0) {
							temp_hero.life = state.player.hero.life + shield
							shield = 0
						} else {
						}
						temp_hero.shield = shield
					}
					else {
						temp_hero.life = state.player.hero.life - value
						if (_.findIndex(state.player.hero.bag, { slug: 'dragon-wing' }) > -1) {
							temp_hero.shield = 0
							for (var i in state.player.hero.bag) {
								if (state.player.hero.bag[i].slug == 'dragon-wing') {
									temp_hero.shield++
								}
							}
						}
					}
					if (_.findIndex(state.player.hero.bag, { slug: 'emerald' }) > -1) {
						if (!_.has(temp_hero, 'gold')) temp_hero.gold = state.player.hero.gold
						for (var i in state.player.hero.bag) {
							if (state.player.hero.bag[i].slug == 'emerald') temp_hero.gold += 4
						}
					}
				}

				// SHIELD
				else if (data.card.type == 'shield') {
					var value = (data.card.value + getters.shield_card_modifier)
					if (value < 0) value = 0

					if (_.findIndex(state.player.hero.bag, { slug: 'ring-of-vitality' }) > -1) {
						temp_hero.life = state.player.hero.life + value
					} else {
						temp_hero.shield = value
						if (_.findIndex(state.player.hero.bag, { slug: 'cursed-shield' }) > -1) {
							temp_hero.shield = state.player.hero.shield + value
						}
						// if (temp_hero.shield < state.player.hero.shield)
						// else
					}
				}

				// HEAL
				else if (data.card.type == 'heal') {
					var value = (data.card.value + getters.heal_card_modifier)
					if (value < 0) value = 0
					temp_hero.life = state.player.hero.life + value
				}

				// GOLD
				else if (data.card.type == 'gold') {
					temp_hero.gold = state.player.hero.gold + data.card.value
					if (!_.has(temp_hero, 'life')) temp_hero.life = state.player.hero.life
					for (var i in state.player.hero.bag) {
						if (state.player.hero.bag[i].slug == 'ruby') temp_hero.life += _.sample([ 0, 0, 0, 1 ])
						if (state.player.hero.bag[i].slug == 'amethyst') temp_hero.gold += data.card.value
						if (state.player.hero.bag[i].slug == 'ring-of-greed') temp_hero.life -= 1
					}
					if (_.findIndex(state.player.hero.bag, { slug: 'amethyst' }) > -1) {
						commit('REMOVE_FROM_HERO_BAG', { slug: 'amethyst' })
					}
				}

				// ITEM
				else if (data.card.type == 'item') {

					if (data.card.allow_multiple || _.findIndex(state.player.hero.bag, { slug: data.card.slug }) == -1) {
						commit('ADD_IN_HERO_BAG', { card: data.card })
					}
				}

				// DROP
				else if (data.card.type == 'drop') {

					commit('ADD_IN_HERO_BAG', { card: data.card })

					var hero_drops = _.filter(state.player.hero.bag, { type: 'drop', slug: 'monster-egg' })
					if (hero_drops.length == 3) {
						for (var i in hero_drops) {
							commit('REMOVE_FROM_HERO_BAG', { slug: 'monster-egg' })
						}
						commit('ADD_IN_HERO_BAG', { card: Generator.get_random_card({ type: 'item', slug: 'omelette' }) })
					}
				}

				if (data.position != getters.current.position) {
					if (_.findIndex(state.player.hero.bag, { slug: 'carrot' }) > -1) {
						if (!_.has(temp_hero, 'life')) temp_hero.life = state.player.hero.life
						for (var i in state.player.hero.bag) {
							if (state.player.hero.bag[i].slug == 'carrot') {
								temp_hero.life++
							}
						}
					}
				}

				if (temp_hero.life && temp_hero.life === 1) {
					if (_.findIndex(state.player.hero.bag, { slug: 'ring-of-courage' }) > -1) {
						var shield = 0
						for (var i in state.player.hero.bag) {
							if (state.player.hero.bag[i].slug == 'ring-of-courage') shield += 5
						}
						if (!_.has(temp_hero, 'shield')) temp_hero.shield = 0
						temp_hero.shield += shield
					}
				}

				if (temp_hero.life > (state.player.hero.life_max + getters.hero_life_max_modifier)) temp_hero.life = (state.player.hero.life_max + getters.hero_life_max_modifier)
				if (temp_hero.life < 0) temp_hero.life = 0
				if (temp_hero.shield < 0) temp_hero.shield = 0

				if (temp_hero) commit('EDIT_PLAYER_HERO', temp_hero)

				commit('EDIT_CURRENT', { status: 'hero-drop', position: data.position })
				commit('EDIT_CARD', { card: data.card, animation: 'die' })


				// BIOME
				if (data.card.type == 'biome') {
					if (state.current.location == 'main') {
						dispatch('next_level', { card: data.card })
						// return false
					} else {
						setTimeout(function() {
							dispatch('leave_place')
						}, 500) // hero drop
						return false
					}
				}

				// PLACE
				else if (data.card.type == 'place') {
					Sounds.play('chest')
					// setTimeout(function() {
					Vue.nextTick(function() {
						dispatch('enter_place', { card: data.card })
					})
					// }, 500) // drop animation
					return false
				}

				// END
				else if (data.card.type == 'end') {
					// setTimeout(function() {
					Vue.nextTick(function() {
						commit('EDIT_CURRENT', { status: 'win' })
						dispatch('edit_account_gold', { value: state.player.hero.gold })
						setTimeout(function() {
							Sounds.play('win')
							dispatch('save_account')
						}, 1000)
					})
					// }, 500) // drop animation
					// return false
				}

				dispatch('check_monster_play')
			}
		},

		check_monster_play: function({ commit, state, dispatch, getters }) {
			var monster_attack = false
			var row = getters.current.board[getters.current.row+1]
			if (row) {
				var card = row.slots[getters.current.position].card
				if (card && card.type == 'monster') {
					monster_attack = true

					if (_.findIndex(state.player.hero.bag, { slug: 'invisibility-cloak' }) > -1) {
						monster_attack = !(state.player.hero.life % 2 == 0)
					}

					if (monster_attack) {
						var sound = 'hit'
						var temp_hero = { }

						var value = (card.value + getters.monster_card_modifier)
						if (state.player.hero.shield > 0) {
							var shield = state.player.hero.shield - value
							if (shield < 0) {
								temp_hero.life = state.player.hero.life + shield
								shield = 0
							} else
								sound = 'shield'
							temp_hero.shield = shield
						} else {
							temp_hero.life = state.player.hero.life - value
							if (_.findIndex(state.player.hero.bag, { slug: 'dragon-wing' }) > -1) {
								temp_hero.shield = 0
								for (var i in state.player.hero.bag) {
									if (state.player.hero.bag[i].slug == 'dragon-wing') {
										temp_hero.shield++
									}
								}
							}
						}

						if (temp_hero.life && temp_hero.life === 1) {
							if (_.findIndex(state.player.hero.bag, { slug: 'ring-of-courage' }) > -1) {
								var shield = 0
								for (var i in state.player.hero.bag) {
									if (state.player.hero.bag[i].slug == 'ring-of-courage') shield += 5
								}
								if (!_.has(temp_hero, 'shield')) temp_hero.shield = 0
								temp_hero.shield += shield
							}
						}

						if (temp_hero.life < 0) temp_hero.life = 0
						
						commit('EDIT_CARD', { card: card, animation: 'monster-attack' })
						dispatch('add_stat', { card: card })

						setTimeout(function() {
							commit('EDIT_CURRENT', { status: 'monster-attack' })
							setTimeout(function() {
								setTimeout(function() {
									commit('EDIT_PLAYER_HERO', temp_hero)
									var type = Generator.get_random_number_by_rates(getters.loot_rates)
									if (type == 'monster')
										var loot = Generator.get_random_card({ type: type, biome: getters.current.biome.slug })
									else
										var loot = Generator.get_random_card({ type: type })
									loot.animation = 'loot'
									commit('TRANSFORM_CARD', { from: card, to: loot })
									setTimeout(function() {
										dispatch('next_turn')
									}, 500) 
								}, 960) // hit animation
							}, 250) // monster alert
						}, 500) // hero drop animation
					}
				}
			}
			if (!monster_attack) {
				setTimeout(function() {
					dispatch('next_turn')
				}, 500) // hero drop animation
			}
		},

		
		enter_place: function({ commit, dispatch }, data) {
			setTimeout(function() {
				commit('EDIT_CURRENT', { position: 1, card: data.card, location: data.card.slug })
				setTimeout(function() {
					dispatch('init_level')
				}, 500)
			}, 500)
		},

		
		leave_place: function({ commit, dispatch }, data) {
			commit('EDIT_CURRENT', { board: [], position: 1, row: 0 })
			Vue.nextTick(function() {
				commit('EDIT_CURRENT', { location: 'main' })
				dispatch('next_turn')
			})
		},


		die: function({ commit, state, dispatch }) {
			commit('EDIT_CURRENT', { status: 'lose' })
			dispatch('edit_account_gold', { value: Math.round(state.player.hero.gold / 2) })
			setTimeout(function() {
				Sounds.play('lose')
				dispatch('save_account')
			}, 1000)
		},

		next_turn: function({ commit, state, dispatch, getters }, data) {
			var dead = false
			if (state.player.hero.life <= 0) {
				if (_.findIndex(state.player.hero.bag, { slug: 'athelas' }) > -1) {
					commit('EDIT_PLAYER_HERO', { life: 1 })
					commit('REMOVE_FROM_HERO_BAG', { slug: 'athelas' })
				} else {
					dead = true
					dispatch('die')
					commit('EDIT_CURRENT', { row: getters.current.row + 1 })
				}
			}
			if (!dead) {
				commit('EDIT_CURRENT', { row: getters.current.row + 1 })
				if (state.current.status != 'win' && state.current.status != 'lose') {
					setTimeout(function() {
						commit('EDIT_CURRENT', { status: 'ready' })
					}, 500)
				}
			}
		},

		next_level: function({ commit, state, dispatch, getters }, data) {
			setTimeout(function() {
				commit('EDIT_CURRENT', { position: 1, level: getters.current.level + 1, biome: data.card, row: 0, board: [] })
				commit('ADD_IN_BIOMES_DONE', { biome: data.card })
				
				if (_.findIndex(state.player.hero.bag, { slug: 'apple' }) > -1) {
					if (_.findIndex(state.player.hero.bag, { slug: 'apple' }) > -1) {
						var life = state.player.hero.life + 10
						if (life > state.player.hero.life_max + getters.hero_life_max_modifier) life = state.player.hero.life_max + getters.hero_life_max_modifier
						commit('EDIT_PLAYER_HERO', { life: life })
					}
				}

				if (_.findIndex(state.player.hero.bag, { slug: 'ring-of-protection' }) > -1) {
					var shield = 0
					for (var i in state.player.hero.bag) {
						if (state.player.hero.bag[i].slug == 'ring-of-protection') shield += 5
					}
					commit('EDIT_PLAYER_HERO', { shield: state.player.hero.shield + shield })
				}

				setTimeout(function() {
					dispatch('init_level')
				}, 500)
			}, 500)
		},

		add_stat: function({ commit, state }, data) {
			if (data.card && _.has(state.stats.cards, data.card.type)) {
				commit('SET_CARD_STAT', { stat: data.card.type, value: state.stats.cards[data.card.type] + 1 })
			}
		}

	},



	mutations: {
		RESET_GAME_STATE: function(state) {
			Object.assign(state, get_default_state())
		},
		SET_GAME_STATE: function(state, data) {
			for (var i in data) {
				Vue.set(state, i, data[i])
			}
		},
		EDIT_CURRENT: function(state, data) {
			var location = state.current.location
			if (data.location) location = data.location

			for (var i in data) {
				if (i == 'status' || i == 'location' || i == 'level' || i == 'biome')
					Vue.set(state.current, i, data[i])
				else
					Vue.set(state.current[location], i, data[i])
			}
		},
		SET_CARD_ON_SLOT: function(state, data) {
			Vue.set(data.slot, 'card', data.card)
		},
		SET_HOVER_CARD: function(state, data) {
			Vue.set(state, 'hover_card', data.card)
		},
		EDIT_PLAYER: function(state, data) {
			for (var i in data) {
				Vue.set(state.player, i, data[i])
			}
		},
		EDIT_PLAYER_HERO: function(state, data) {
			for (var i in data) {
				Vue.set(state.player.hero, i, data[i])
			}
		},
		ADD_IN_HERO_BAG: function(state, data) {
			state.player.hero.bag.push(data.card)
		},
		ADD_IN_BIOMES_DONE: function(state, data) {
			state.biomes.done.push(data.biome)
		},
		REMOVE_FROM_HERO_BAG: function(state, data) {
			var index = _.findIndex(state.player.hero.bag, { slug: data.slug })
			if (index > -1) state.player.hero.bag.splice(index, 1)
		},
		SET_ANIMATION: function(state, data) {
			Vue.set(data.card, 'animation', data.name)
			Vue.set(state.current, 'animation', data)
		},
		SET_CARD_STAT: function(state, data) {
			Vue.set(state.stats.cards, data.stat, data.value)
		},
		EDIT_CARD: function(state, data) {
			for (var i in data) {
				if (i != 'card') {
					Vue.set(data.card, i, data[i])
				}
			}
		},
		TRANSFORM_CARD: function(state, data) {
			Object.keys(data.to).forEach(function(key) {
				Vue.set(data.from, key, data.to[key])
			})
		}
	}

}

export default game